<template>
  <div>
    <b-row class="mx-0">
      <b-col style="padding-top: 3.5rem;">
        <div
          style="font-family: 'Poppins', sans-serif; padding:.25rem .5rem; background: #F1F1F1; font-variant: all-small-caps; display: inline-block "
        >
          {{category}}
        </div>
        <div
          style="font-weight: bold; line-height: 1.3em; margin: .5rem 0px; font-size: xx-large"
        >
          {{data.title}}
        </div>
        <div style="font-size: larger;">
          {{data.description}}
        </div>
        <div :style="'width:100%; height: 350px; border-radius: 1rem; margin-top: .5rem; background: url(\''+data.image+'\'); background-size: cover; background-position: center;'" />
        <div
          style="font-family: 'Poppins', sans-serif; font-size: x-small; margin-top: 1rem; margin-bottom: .5rem; color: rgba(0,0,0,.5);"
        >
          {{data.publishdate}}
        </div>
        <span v-html="data.content"></span>
      </b-col>
      <b-col cols="3" style="padding-top: 3.5rem;">
        <new-news :data="novedades[0]"></new-news>
        <new-news :data="novedades[1]"></new-news>
        <new-news :data="novedades[2]"></new-news>
        <new-news :data="novedades[3]"></new-news>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import NewNews from "@/components/Noticias/New.vue";
import axios from "axios";

export default {
  components: {
    NewNews
  },
  data() {
    return {
      data: {},
      novedades: [],
      loading: true
    }
  },
  computed:{
    category(){
      let category = 'GENERAL';
      if (this.data && this.data.theme){
        category = this.data.theme
      }
      return category;
    },
  },
  mounted(){
    this.updatenews();
  },
  methods:{
    async updatenews(){
      console.log(this.$store.state.user.siteData);
      this.data = await axios
        .post(
          this.$store.state.user.siteData.location + "news/news/getDetails",
          JSON.stringify({id: this.$route.params.id}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.loading = false;
          const records = evtResponse.data.records[0]; 
          return records;
        });

      this.novedades = await axios
        .post(
          this.$store.state.user.siteData.location + "news/news/getAll",
          JSON.stringify({type: 'list'}),
          {
            validateStatus(status) {
              return status < 500; // Resolve only if the status code is less than 500
            },
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(evtResponse => {
          console.log(evtResponse.data);
          this.loading = false;
          const records = evtResponse.data.records; 
          return records;
        });
    },
  }
};
</script>
